const styles: { [key: string]: React.CSSProperties } = {
  button: {
    display: "flex",
    justifyContent: "flex-end",
  },
};

export default styles;
